export function round(value: number, precision: number) {
  var factor = Math.pow(10, precision);
  var tempNumber = value * factor;
  var roundedTempNumber = Math.round(tempNumber);
  return roundedTempNumber / factor;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/round.tsx